
import { Stack, Typography } from "@mui/material";
import { ReactNode, useMemo } from "react";

interface InfoBannerProps {
    title: string | ReactNode
    subText: string | ReactNode
    styles?: {
        bgColor: string
        borderStyle: string
    }
}

const InfoBanner = ({
    title,
    subText,
    styles = {
        bgColor: '',
        borderStyle: ''
    }
}: InfoBannerProps) => {
    const { bgColor, borderStyle } = useMemo(() => {
        return styles;
    }, [styles]);

    return (
        <Stack
            border={borderStyle}
            borderRadius="8px"
            p="16px"
            alignItems="center"
            justifyContent="center"
            bgcolor={bgColor}
            data-testid="info-banner"
        >
            { typeof title === 'string' ? (
                <Typography data-testid="info-banner-title" variant="h4">
                    {title}
                </Typography>
            ) : title }

            { typeof subText === 'string' ? (
                <Typography data-testid="info-banner-subtext" variant="body1">
                    {subText}
                </Typography>
            ) : subText }
        </Stack>
    );
};
export default InfoBanner;
